var _rect, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovastayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 108,
    fill: "#074498"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 78,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontSize: 70,
    fontWeight: 700,
    letterSpacing: -2
  }, "\n    NOVASTAY\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovastayLogo);
export default __webpack_public_path__ + "static/media/novastay-logo.0212f8ae07dbe5f60e591420b6684f7e.svg";
export { ForwardRef as ReactComponent };